import { render, staticRenderFns } from "./SidFlexDirection.vue?vue&type=template&id=158c39d0"
import script from "./SidFlexDirection.vue?vue&type=script&lang=js"
export * from "./SidFlexDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports